export default {"src":"/_next/static/media/americanExpressLogo.0cc959a5.svg","height":15,"width":22,"blurWidth":0,"blurHeight":0};